/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2xpYnJhcnkvY29tcG9uZW50cy9jb21wb25lbnRzL2ZpbHRlcnMvZGF0ZS1zaW1wbGUtcmFuZ2UvZGF0ZS1zaW1wbGUtcmFuZ2UuY29tcG9uZW50LnNjc3MifQ== */"];
export { styles as styles };
